import React, { useState, useEffect, useContext } from "react";
import { Paper } from "@mui/material";
import { MdManageAccounts } from "react-icons/md";
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import './../../../Style/Produce.scss'
import axios from "axios";
import { ApiLink } from '../../../APILink/ApiLink';
import authHeader from '../../../Auth/authHeader';
import { errorAlert } from '../../../Components/Alerts';
import { FaTable } from "react-icons/fa";
import Autocomplete from "@mui/material/Autocomplete";
import { ElementsParagraph, TitleElements } from "../../../Components/HeadersCRUD-s";
import { HeaderPaperComponent } from "../../../Components/HeaderPaperComponent";
import { LinkAndClickButton } from "../../../Components/AddElementsButton";
import { FaTimes } from "react-icons/fa";
import { ArticleReceptureDetails, ProduceArticle } from "./MillProduceGrid";
import DataGridComponent from "../../../Components/DataGridComponent";
import { FiscalYearContext } from "../../../FiscalYear/FiscalYearContext";
import { TextareaAutosize } from '@mui/material';
import PrintFletProdhimin from "../../../Print/PrintFletProdhiminMulliri";
import ButtonGroup from '@mui/material/ButtonGroup';
import MuiButton from '@mui/material/Button';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Popper from '@mui/material/Popper';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

function NewMillProduce() {
    const { fiscalYear } = useContext(FiscalYearContext);

    const [lendapare, setLendaPare] = useState([]);
    const [rows, setRows] = useState([]);

    const [lendaPareDetale, setLendaPareDetale] = useState([]);

    // const [qtyIninventory, setQtyInInventory] = useState(0);
    const [openDetails, setOpenDetails] = useState(false);
    const [showTable, setShowTable] = useState(false);

    const [hasElectronicSeal, setHasElectronicSeal] = useState(null);
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef(null);

    const [showCalculation, setShowCalculation] = useState(false);

    const [componentNumber, setComponentNumber] = useState(0);
    const [articleID, setArticleID] = useState(0);
    const [articles, setArticles] = useState([]);

    const [showInventoryMsg, setShowInventoryMsg] = useState(false);
    const [txtMsg, setTxtMsg] = useState("");

    const [transactionID, setTransactionID] = useState(0);
    const [qty, setQty] = useState(1);
    const [price, setPrice] = useState(0);
    const [date, setDate] = useState("");
    const [comment, setComment] = useState("");
    const [invoiceNR, setInvoiceNR] = useState("");
    const [unId, setUnID] = useState('')

    const [changeButton, setChangeButton] = useState(false)
    const [headerData, setHeaderData] = useState([]);
    const [companiesData, setCompaniesData] = useState([]);

    const [disabledButton, setDisabledButton] = useState(false);
    const [disabledQty, setDisabledQty] = useState(false);
    const [editButton, setEditButton] = useState(false);

    const [minDate, setMinDate] = useState('');
    const [maxDate, setMaxDate] = useState('');

    useEffect(() => {
        setMinDate(`${fiscalYear}-01-01`);
        setMaxDate(`${fiscalYear}-12-31`);
    }, [fiscalYear])

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };

    const handleEnable = () => {
        setForm1IsDisabled(true);
    }

    const headers = authHeader();

    const [data, setData] = useState([]);

    const [form1IsDisabled, setForm1IsDisabled] = useState(false);

    const fetchArticlesProduction = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'MillProduce/getNormative', { headers });
            setArticles(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);

            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const fetchrecepture = async (id) => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'MillProduce/articleReceptureDetails', {
                headers,
                params: { componentNumber: id, invNumber: invoiceNR, fiscalYear: fiscalYear }
            });
            setData(response.data);
            setShowTable(true);
            return response.data || [];
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);

            if (error.response) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage || "Gabim nga serveri."}`);
            } else if (error.request) {
                errorAlert("Serveri nuk është i arritshëm. Kontrolloni lidhjen me internetin ose provoni më vonë.");
            } else {
                errorAlert(`Gabim: ${error.message}`);
            }
            return [];
        }
    };

    const getLendaPareDetale = async (id) => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'MillProduce/lendaPareDetale', {
                headers,
                params: { articleID: id }
            });

            setLendaPareDetale(response.data || []);

            setPrice(response.data?.[0]?.CmimiMesatar ?? 0);
            setShowTable(true);

            return response.data || [];
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);

            if (error.response) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage || "Gabim nga serveri."}`);
            } else if (error.request) {
                errorAlert("Serveri nuk është i arritshëm. Kontrolloni lidhjen me internetin ose provoni më vonë.");
            } else {
                errorAlert(`Gabim: ${error.message}`);
            }

            return [];
        }
    };

    const fetchLastInvoiceNr = async (fiscalY) => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'MillProduce/InvoiceNr', { headers, params: { fiscalYear: fiscalY } });
            setInvoiceNR(response.data.NextInvoiceNr);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const fetchHeaderData = async (invNumber) => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'MillProduce/GetPrintHeaderDetails', { headers, params: { invNumber: invNumber, actionType: "PRD", fiscalYear: fiscalYear } });
            setHeaderData(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const fetchCompaniesData = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Companies/getCompanyDetails', { headers });
            setCompaniesData(response.data);
            setHasElectronicSeal(response.data[0].ElectronicSeal);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const fetchUnId = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'UserDetails/GetUnitIDByUserID', { headers });
            // setUnID(response.data.CompanyUnit_ID);
            setUnID(response.data.CompanyUnit_ID ?? 0);

        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const keepproducing = () => {
        setShowInventoryMsg(false);
        setTxtMsg("")
        setDisabledQty(false);
        setDisabledButton(false);
        fetchrecepture(componentNumber);
    }

    const fetchArticleInventory = async (articleID, number) => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'AccountingBooks/inventoryByArticleID', { headers, params: { articleID: articleID, fiscalYear: fiscalYear } });
            const articleInventory = (response.data?.[0]?.TotalQtyInStock ?? 0);

            if (articleInventory <= 0) {
                setShowInventoryMsg(true);
                setDisabledQty(true);
                setDisabledButton(true);
                setTxtMsg(`Ky artikull nuk ka sasi në stok! Sasia e disponueshme është: ${articleInventory}.`);
            }
            else {
                setShowInventoryMsg(false);
                fetchrecepture(number);
                setTxtMsg("")
            }
            // setQtyInInventory(articleInventory);


            // console.log(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };


    const handleSubmit = (event) => {
        event.preventDefault();

        if (!date) {
            errorAlert("Ju lutem plotësoni datën!");
            return;
        }

        const stateDate = {
            Date: date,
            InvoiceNr: invoiceNR,
            Comment: comment,
            CompanyUnitID: unId > 0 ? unId : null

        };
        axios.post(ApiLink.API_URL + 'MillProduce', stateDate, { headers })
            .then(() => {
                // handleSuccess("Accounting Sheet Added Successfully");
                handleEnable();
                setOpenDetails(true);
                fetchTransactionID(invoiceNR, fiscalYear);
                fetchHeaderData(invoiceNR);
                setChangeButton(true);
            })
            .catch((error) => {
                console.error("Gabim nga serveri:", error);

                if (error.response) {
                    console.error("Statusi i gabimit:", error.response.status);
                    console.error("Mesazhi nga serveri:", error.response.data);

                    // Shfaq gabimin specifik nga backend-i
                    errorAlert(`Gabim (${error.response.status}): ${error.response.data}`);
                } else if (error.request) {
                    console.error("Nuk ka përgjigje nga serveri:", error.request);
                    errorAlert("Nuk ka përgjigje nga serveri. Kontrolloni lidhjen.");
                } else {
                    console.error("Gabim gjatë kërkesës:", error.message);
                    errorAlert("Gabim gjatë dërgimit të kërkesës.");
                }
            });
    };

    const saveAndNew = () => {
        setChangeButton(false);
        setOpenDetails(false);
        setShowTable(false);
        setForm1IsDisabled(false);
        setShowCalculation(false);
        setArticleNameField(null);
        setArticleID(0);
        setQty(0);
        fetchLastInvoiceNr(fiscalYear);
        setDate("");
        setComment("");
        setShowInventoryMsg(false);
        setDisabledQty(false);
        setDisabledButton(false);
    }

    // const handleNewSubmit = (event, action) => {
    //     event.preventDefault();

    //     if (!articleID) {
    //         errorAlert("Zgjedheni artikullin, për të vazhduar");
    //         return
    //     }
    //     if (!qty) {
    //         errorAlert("Plotësoni sasinë, për të vazhduar");
    //         return
    //     }

    //     const payload = {
    //         ArtProdDto: {
    //             TransactionID: transactionID,
    //             ArticleProductionID: articleID,
    //             ComponentNumber: componentNumber,
    //             Date: date,
    //             QtyInput: qty,
    //             Price: price,
    //         },
    //         ReceptureDetails: data, // Array nga useState
    //     };
    //     axios.post(ApiLink.API_URL + "MillProduce/produceProduct", payload, { headers, params: { action: action } })
    //         .then(() => {
    //             // handleSuccess("Receptura u shtua me sukses");
    //             setShowCalculation(true);
    //             setEditButton(false);
    //             setDisabledButton(true);
    //             setDisabledQty(true);
    //             setIsProcessingComplete(true);


    //             fetchrecepture(componentNumber);

    //         })
    //         .catch((error) => {
    //             console.error("Gabim gjatë dërgimit:", error);

    //             if (error.response) {
    //                 console.error("Përgjigja nga serveri:", error.response.data);

    //                 if (error.response.status === 409) {
    //                     errorAlert(error.response.data);
    //                 } else if (error.response.status === 400) {
    //                     errorAlert("Të dhënat nuk janë të sakta. Kontrolloni nëse keni plotësuar çdo fushë.");
    //                 } else if (error.response.status === 500) {
    //                     errorAlert(`Gabim ne kalkulime`);
    //                 } else {
    //                     errorAlert(`Ndodhi një gabim: ${error.response.data}`);
    //                 }
    //             } else if (error.request) {
    //                 errorAlert("Serveri nuk është i arritshëm. Kontrolloni lidhjen tuaj me internetin.");
    //             } else {
    //                 errorAlert("Ndodhi një gabim i panjohur gjatë dërgimit të të dhënave.");
    //             }
    //         });
    // };

    const handleNewSubmit = async (event, action) => {
        event.preventDefault();

        if (!articleID) {
            errorAlert("Zgjedheni artikullin, për të vazhduar");
            return;
        }
        if (!qty) {
            errorAlert("Plotësoni sasinë, për të vazhduar");
            return;
        }

        const payload = {
            ArtProdDto: {
                TransactionID: transactionID,
                ArticleProductionID: articleID,
                ComponentNumber: componentNumber,
                Date: date,
                QtyInput: qty,
                Price: price,
            },
            ReceptureDetails: data,
        };

        try {
            const response = await axios.post(
                ApiLink.API_URL + "MillProduce/produceProduct",
                payload,
                { headers, params: { action: action } }
            );

            if (response.status === 200) { // Sigurohemi që kërkesa u krye me sukses
                setShowCalculation(true);
                setEditButton(false);
                setDisabledButton(true);
                setDisabledQty(true);

                // // Prit pak që React të përpunojë ndryshimet e state
                // await new Promise((resolve) => setTimeout(resolve, 50));

                // // Fetch recepture vetëm pasi të gjitha ndryshimet janë aplikuar
                // fetchrecepture(componentNumber);
            }
        } catch (error) {
            console.error("Gabim gjatë dërgimit:", error);

            if (error.response) {
                console.error("Përgjigja nga serveri:", error.response.data);

                switch (error.response.status) {
                    case 409:
                        errorAlert(error.response.data);
                        break;
                    case 400:
                        errorAlert("Të dhënat nuk janë të sakta. Kontrolloni nëse keni plotësuar çdo fushë.");
                        break;
                    case 500:
                        errorAlert("Gabim në kalkulime");
                        break;
                    default:
                        errorAlert(`Ndodhi një gabim: ${error.response.data}`);
                }
            } else if (error.request) {
                errorAlert("Serveri nuk është i arritshëm. Kontrolloni lidhjen tuaj me internetin.");
            } else {
                errorAlert("Ndodhi një gabim i panjohur gjatë dërgimit të të dhënave.");
            }
        }
    };


    //Pjesa per select input field artikull 
    const [articleNameField, setArticleNameField] = useState(null)
    const handleAutocompleteChangearticle = (event, value) => {
        if (value && value.ArticleID) {
            setArticleID(value.ArticleID);
            setComponentNumber(value.ComponentNumber);
            setArticleNameField(value);
            getLendaPareDetale(value.ArticleID);
            fetchArticleInventory(value.ArticleID, value.ComponentNumber);
        } else {
            setArticleID(0);
        }
    };

    const defaultPropsArticle = {
        options: articles,
        getOptionLabel: (option) =>
            ` ${option.ComponentsName}` || "",
        renderOption: (props, option) => (
            <>
                <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
                    <span>
                        {option.Barcode}-{"Lënda parë"}-{option.ArticleName} <br />
                        <b> {option.ComponentsName}</b>
                    </span>
                </li>
            </>
        ),
    };

    const changeButtons = () => {
        setEditButton(true)
        setDisabledQty(false);
        fetchrecepture(componentNumber);
    }

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            let nextField;
            switch (e.target.id) {
                case 'ArticleID':
                    nextField = document.getElementById('Qty');
                    break;
                case 'Qty':
                    if (editButton === true) {
                        handleNewSubmit(e, "edit");
                    } else if (editButton === false) {
                        handleNewSubmit(e, "insert");
                    }
                    // nextField = document.getElementById('ArticlesID');
                    break;
                default:
                    return;
            }
            if (nextField && nextField.select) {
                nextField.focus();
                nextField.select(); // Shtoni këtë rresht për të selektuar tekstin
            }
        }
    };

    const fetchTransactionID = async (inv, fiscal) => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'MillProduce/GetTransactionID', { headers, params: { invNumber: inv, fiscalYear: fiscal } });
            setTransactionID(response.data);
            // Kontrollo nëse nuk ka të dhëna të disponueshme
            if (response.data.length === 0) {
                // Shfaqi një mesazh për përdoruesin
                // errorAlert("No data available.");
            }
        } catch (error) {
            // Shfaqi një mesazh për përdoruesin për gabimin e tjera
            // setMessage("Error: Failed to fetch data.");
        }
    };

    //shfaq te dhenat ne grid  per lenden e pare, si dhe lendaPare shkon per printim
    useEffect(() => {
        const newRows = lendaPareDetale.map((item, index) => ({
            id: index + 1,
            articleID: item.ArticleProductionID,
            recepture: item.ArticleName,
            qty: qty,
            price: item.CmimiMesatar,
            value: Number(item.CmimiMesatar) * Number(qty),
            artUnit: item.UnitName
        }));
        setLendaPare(newRows);
    }, [qty, lendaPareDetale]);

    //shfaq te dhenat ne grid  per produktet e prodhuara, si dhe rows shkon per printim
    useEffect(() => {
        const newRows = data.map((item, index) => ({
            id: index + 1, // Përdor index + 1 në vend të ++index
            articleID: item.ArticleID, // Shtojmë ArticleID për krahasim
            recepture: item.ArticleName,
            qty: qty !== 0 ? Number(item.SasiaFillestare) * Number(qty) : item.SasiaFillestare,
            price: price,
            value: (Number(price) * (Number(item.SasiaFillestare) * Number(qty))),
            artUnit: item.UnitName
        }));

        setRows(newRows);
    }, [qty, data, price]);

    useEffect(() => {
        fetchArticlesProduction();
        fetchCompaniesData();
        fetchUnId();
    }, []);

    useEffect(() => {
        fetchLastInvoiceNr(fiscalYear);
    }, [fiscalYear]);

    return (
        <div className="NewProduce__Container" style={{ paddingTop: "50px" }}>
            <TitleElements
                icon={MdManageAccounts}
                title="Krijo Prodhim të ri"
            />
            <ElementsParagraph text="Ju lutemi vini re se të gjitha te dhenat ruhen automatikisht në bazën e të dhënave për të pasur siguri në cdo hap!" />
            <hr></hr>
            <div className="NewProduce__Container__AllButtons">
                <div style={{ display: "flex", }}>
                </div>
                <div style={{ display: "flex" }}>
                    {changeButton ? (
                        <>
                            <div style={{ marginLeft: "5px" }}>
                                <ButtonGroup
                                    variant="contained"
                                    ref={anchorRef}
                                >
                                    <PrintFletProdhimin details={headerData} companyDetails={companiesData} produceArticle={lendapare} recepture={rows} hasElectronicSeal={hasElectronicSeal} />
                                    <MuiButton
                                        style={{ width: "30px", height: "35px", marginTop: "10px", borderRadius: ("0 5px 5px 0"), backgroundColor: "#4E7B67" }}
                                        aria-controls={open ? 'split-button-menu' : undefined}
                                        aria-expanded={open ? 'true' : undefined}
                                        // aria-label="select print option"
                                        aria-haspopup="menu"
                                        onClick={handleToggle}
                                    >
                                        <ArrowDropDownIcon />
                                    </MuiButton>
                                </ButtonGroup>
                                <Popper
                                    sx={{ zIndex: 1 }}
                                    open={open}
                                    anchorEl={anchorRef.current}
                                    role={undefined}
                                    transition
                                    disablePortal
                                >
                                    {({ TransitionProps, placement }) => (
                                        <Grow
                                            {...TransitionProps}
                                            style={{
                                                transformOrigin:
                                                    placement === 'bottom' ? 'center top' : 'center bottom',
                                            }}
                                        >
                                            <Paper>
                                                <ClickAwayListener onClickAway={handleClose}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={hasElectronicSeal} // Lidh me `ElectronicSeal`
                                                                onChange={(event) => setHasElectronicSeal(event.target.checked)} // Përditëson `ElectronicSeal` kur klikohet
                                                            />
                                                        }
                                                        label="Shfaq Vulen Elektronike"
                                                    />
                                                </ClickAwayListener>
                                            </Paper>
                                        </Grow>
                                    )}
                                </Popper>
                            </div>
                            <div style={{ marginLeft: "5px" }}>
                                <LinkAndClickButton
                                    text="Ruaj & i Ri"
                                    link="#"
                                    onClick={saveAndNew}
                                />
                            </div>
                            <div style={{ marginLeft: "5px" }}>
                                <LinkAndClickButton
                                    text="Ruaj & Mbyll"
                                    icon={<FaTimes />}
                                    link="/produc/produce"
                                />
                            </div>
                        </>
                    ) : (
                        <div style={{ marginLeft: "5px" }}>
                            <LinkAndClickButton
                                text="Mbyll"
                                icon={<FaTimes />}
                                link="/produc/produce"
                            />
                        </div>
                    )}
                </div>
            </div>
            <HeaderPaperComponent />
            <Paper>
                <div className="NewProduce__Container__FirstForm">
                    <form
                        //onSubmit={handleNewSubmit}
                        // className='header_paper'
                        onKeyPress={handleKeyPress}>
                        <Box
                            // // component="form"
                            // sx={{
                            //     '& .MuiTextField-root': { m: 1.3, width: '41ch' },
                            // }}
                            noValidate
                            autoComplete="off"
                        >
                            <div className="NewProduce__Container__FirstForm__Row1" >
                                <div className="NewProduce__Container__FirstForm__Row1__div">
                                    <TextField
                                        className="NewProduce__Container__Form__TextField__1"
                                        required
                                        id="invoiceNR"
                                        label="Numri i Fletë Prodhimit"
                                        variant="outlined"
                                        type="text"
                                        name='InvoiceNr'
                                        value={"PRD-" + fiscalYear + "-" + invoiceNR}
                                        onChange={event => setInvoiceNR(event.target.value)}
                                        disabled={form1IsDisabled}
                                        autoComplete="off"
                                        aria-readonly
                                    />
                                </div>
                                <div className="NewProduce__Container__FirstForm__Row1__div">
                                    <TextField
                                        className="NewProduce__Container__Form__TextField__1"
                                        id="date"
                                        type="date"
                                        variant="outlined"
                                        name='Date'
                                        value={date}
                                        onChange={(e) => setDate(e.target.value)}
                                        disabled={form1IsDisabled}
                                        inputProps={{
                                            min: minDate, // Kufizimi minimal i datës
                                            max: maxDate, // Kufizimi maksimal i datës
                                        }}
                                    />
                                </div>
                                <div className="NewProduce__Container__FirstForm__Row1__div">
                                    <TextareaAutosize
                                        className="NewProduce__Container__Form__Description"
                                        id="Description"
                                        placeholder='Përshkrimi'
                                        type="text"
                                        autoComplete='off'
                                        name='Description'
                                        value={comment}
                                        onChange={event => setComment(event.target.value)}
                                        style={{ resize: 'none' }}
                                    />

                                </div>
                            </div>
                        </Box>
                    </form>
                    <br></br>
                    <br></br>
                    {
                        openDetails ?
                            <div className="SalesDetail__Container">
                                <div style={{ backgroundColor: "gainsboro " }}>
                                    {showInventoryMsg && (
                                        <div style={{
                                            backgroundColor: "#fdecea",
                                            borderLeft: "4px solid #d32f2f",
                                            color: "#d32f2f",
                                            padding: "16px",
                                            borderRadius: "8px",
                                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                            marginBottom: "16px"
                                        }}>
                                            <p>
                                                {txtMsg}
                                            </p>
                                            <p style={{ color: "#388e3c", marginTop: "8px" }}>
                                                Nëse dëshironi të vazhdoni prodhimin, klikoni më poshtë:
                                            </p>
                                            <button
                                                onClick={keepproducing}
                                                style={{
                                                    marginTop: "12px",
                                                    backgroundColor: "#388e3c",
                                                    color: "#fff",
                                                    padding: "8px 16px",
                                                    borderRadius: "6px",
                                                    border: "none",
                                                    cursor: "pointer",
                                                    fontWeight: "bold"
                                                }}
                                                onMouseOver={(e) => e.target.style.backgroundColor = "#2e7d32"}
                                                onMouseOut={(e) => e.target.style.backgroundColor = "#388e3c"}
                                            >
                                                Vazhdo prodhimin
                                            </button>
                                        </div>
                                    )}
                                    <form className='header_paper' onKeyPress={handleKeyPress}>
                                        <Box
                                            // component="form"
                                            sx={{
                                                '& .MuiTextField-root': { m: 1.3, width: '41ch' },
                                            }}
                                            noValidate
                                            autoComplete="off"
                                        >
                                            <div className='NewProduce__Container__FirstForm__Row1'>
                                                <div style={{ width: "90%" }}>
                                                    <Autocomplete
                                                        fullWidth
                                                        {...defaultPropsArticle}
                                                        id="ArticleID"
                                                        disabled={disabledButton}
                                                        includeInputInList
                                                        value={articleNameField}
                                                        onChange={handleAutocompleteChangearticle}
                                                        isOptionEqualToValue={(option, value) => option.ArticleID === value.ArticleID}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                style={{ width: "90%" }}
                                                                {...params}
                                                                label="Zgjedh Normativin"
                                                            />
                                                        )}
                                                        ListboxProps={{
                                                            style: {
                                                                maxHeight: '250px',
                                                                overflow: 'auto',
                                                            },
                                                        }}
                                                    />
                                                </div>
                                                <div className='box3'>
                                                    <TextField
                                                        className="AccountingSheet__Container__Form__TextField__5"
                                                        id="Qty"
                                                        label="Sasia"
                                                        variant="outlined"
                                                        autoComplete="off"
                                                        name='QTY'
                                                        disabled={disabledQty}
                                                        value={qty}
                                                        onChange={event => { setQty(event.target.value); }}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    />
                                                </div>
                                                {
                                                    editButton ?
                                                        <div className="butonat">
                                                            <button type="submit"
                                                                className="btn btn-primary float-end"
                                                                style={{ background: "#284945", width: "110px", marginLeft: "15px" }}
                                                                onClick={(event) => handleNewSubmit(event, "edit")}
                                                            >Ndrysho</button>
                                                        </div>
                                                        :
                                                        <div className="butonat">
                                                            <button type="submit"
                                                                disabled={disabledButton}
                                                                className="btn btn-primary float-end"
                                                                style={{ background: "#284945", width: "110px", marginLeft: "15px" }}
                                                                onClick={(event) => handleNewSubmit(event, "insert")}
                                                            >Prodho</button>
                                                        </div>
                                                }
                                            </div>
                                        </Box>
                                    </form>
                                </div>
                            </div>
                            : <div style={{ display: "flex", justifyContent: "space-around", width: "100%" }}>
                                <button className="button-15" variant="contained"
                                    type="submit"
                                    style={{
                                        background: "#284945",
                                        width: "95%",
                                        height: "55px",
                                        alignContent: "center",
                                        transition: "background-color 0.3s ease",
                                        boxShadow: "0 0 5px rgba(0, 0, 0, 0.3)",
                                        color: "white",
                                        border: "none"
                                    }}
                                    disabled={form1IsDisabled}
                                    onClick={handleSubmit}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = "#4E7B67";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = "#284945";
                                    }}
                                >
                                    <FaTable />  Vazhdo me prodhimin e produktit
                                </button>
                            </div>
                    }
                    <br></br>
                    <br></br>
                    {
                        showCalculation ?
                            <div>
                                <ElementsParagraph text="Lënda e parë, që do të përpunohet" />
                                <DataGridComponent
                                    columns={ProduceArticle({ changeButtons })}
                                    rows={lendapare}
                                    height={"auto"}
                                />
                            </div>
                            :
                            null
                    }
                    <br></br>
                    {
                        showTable ?
                            <div>
                                <ElementsParagraph text="Ne tabelë janë paraqitur recepturat qe shërbejnë për ta prodhuar produktin e zgjedhur" />
                                <DataGridComponent
                                    columns={ArticleReceptureDetails}
                                    rows={rows}
                                    height={"auto"}
                                />
                                <br></br>
                            </div>
                            :
                            null
                    }
                    <br></br>
                </div>
            </Paper >
        </div >
    );
}

export default NewMillProduce;